<template>
    <div class="tooltip-wrapper">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "Tooltip",

        data() {
            return {
                open: false
            }
        },

        watch: {
            open: function (newOpen, oldOpen) {
                this.checkState();
            }
        },

        mounted() {
            let component = this;

            $(this.$el).find('a.tooltip-trigger').on('click', function (event) {
                event.preventDefault();
                component.toggle();
            })
        },

        methods: {
            toggle: function() {
                this.open = !this.open;
            },

            checkState: function () {
                if (this.open && !this.isOpen) {
                    this.openTip();
                } else if (!this.open && this.isOpen) {
                    this.closeTip();
                }
            },

            openTip: function() {
                this.$el.setAttribute('state-active', 'true');
                this.isOpen = true;
            },

            closeTip: function() {
                this.$el.setAttribute('state-active', 'false');
                this.isOpen = false;
            }
        }
    }
</script>

<style scoped>

</style>